<template>
    <div>
        <div class="page-wrapper">
            <div class="page-body">
                <div class="row g-2">
                    <div class="col">
                        <ChatsList />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ChatsList from "../components/ChatsList"
import { store } from "../store"

export default {
    name: "ChatsPage",
    components: {
        ChatsList
    },
    data() {
        return {
            chats: []
        }
    },
    async mounted() {
        store.showSidebar = true
        store.showHeader = true
        store.showGroupButton = true
    }
}
</script>
